import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../AuthService';
import { useAuth } from '../../AuthContext';
import PremiumUpsellModal from '../PremiumUpsellModal/PremiumUpsellModal';
import MapPaywallSheet from '../MapPaywallSheet/MapPaywallSheet';
import { MapPreviewProvider } from '../../contexts/MapPreviewContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const ProtectedRoute = ({ children, requirePremium = false, feature = null }) => {
  const { user, isLoading } = useAuth();
  const [initialised, setInitialised] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const sheetFocusRef = useRef(null);
  const navigate = useNavigate();

  const hasPremium = AuthService.isPremiumActiveUser(user);
  const isAuthorized = requirePremium ? hasPremium : Boolean(user);
  const isMapPreview = feature === 'map' && requirePremium && !hasPremium;

  useEffect(() => {
    if (!isLoading) {
      setInitialised(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!initialised) return;
    setShowModal(!isAuthorized);
  }, [initialised, isAuthorized]);

  const handleModalClose = () => {
    setShowModal(false);
    navigate('/');
  };

  const focusSheet = () => {
    const node = sheetFocusRef.current;
    if (!node) return;
    const heading = node.querySelector('#map-paywall-title');
    (heading || node).focus?.();
  };

  if (!initialised) {
    return <LoadingSpinner message="Indlæser..." size="medium" fill />;
  }

  if (isMapPreview) {
    return (
      <MapPreviewProvider isPreview focusSheet={focusSheet}>
        {children}
        <MapPaywallSheet
          isOpen={showModal}
          onClose={handleModalClose}
          user={user}
          sheetRef={sheetFocusRef}
        />
      </MapPreviewProvider>
    );
  }

  if (!isAuthorized) {
    return (
      <>
        <PremiumUpsellModal
          isOpen={showModal}
          onClose={handleModalClose}
          feature={feature}
          user={user}
        />
        <div style={{ display: 'none' }}>
          {children}
        </div>
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
